import apiClient from "./api";

export const createEmployee = async (employeeData) => {
  try {
    // Ensure branch and location are arrays
    const employeePayload = {
      ...employeeData,
      branch: Array.isArray(employeeData.branch)
        ? employeeData.branch
        : [employeeData.branch],
      location: Array.isArray(employeeData.location)
        ? employeeData.location
        : [employeeData.location]
    };

    const response = await apiClient.post("/register", employeePayload);
    return response.data;
  } catch (error) {
    console.error("Error creating employee:", error);
    throw error;
  }
};